import React from "react";
import { toast } from "sonner";

const DIRS = ["Nord", "Nord-Est", "Est", "Sud-Est", "Sud", "Sud-Ovest", "Ovest", "Nord-Ovest"];
export const dirName = (az) => DIRS[Math.round((((az % 360) + 360) % 360) / 45) % 8];

const LETTERS = [["N", 0], ["E", 90], ["S", 180], ["O", 270]];

export const CompassRose = ({ rotation = 0, faldaAz, lat, lng }) => {
  const hasAz = faldaAz !== null && faldaAz !== undefined && !Number.isNaN(Number(faldaAz));
  const az = hasAz ? Math.round(Number(faldaAz)) : 0;
  const hasCoord = lat !== null && lat !== undefined && lng !== null && lng !== undefined && lat !== "" && lng !== "";
  const coordTxt = hasCoord ? `${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}` : "";
  const copy = () => {
    navigator.clipboard?.writeText(coordTxt).then(() => toast.success("Coordinate copiate"), () => toast.error("Copia non riuscita"));
  };
  return (
    <div className="absolute right-2 top-14 md:top-auto md:bottom-2 z-[5] w-[118px] p-2 rounded-[10px] flex flex-col items-center gap-1 pointer-events-auto"
      style={{ background: "#ffffffeb" }} data-testid="roof-compass-rose">
      <svg viewBox="-50 -50 100 100" width="88" height="88" aria-label="Bussola">
        <circle r="46" fill="#fff" stroke="#cbd5e1" strokeWidth="2" />
        <g transform={`rotate(${rotation})`} style={{ transition: "transform .2s ease" }}>
          {Array.from({ length: 24 }).map((_, i) => (
            <line key={i} x1="0" y1="-46" x2="0" y2={i % 6 === 0 ? -38 : -42} stroke="#94a3b8" strokeWidth={i % 6 === 0 ? 2 : 1} transform={`rotate(${i * 15})`} />
          ))}
          <polygon points="0,-34 6,0 -6,0" fill="#B30000" />
          <polygon points="0,34 6,0 -6,0" fill="#475569" />
          {hasAz && (
            <g transform={`rotate(${az})`} data-testid="roof-compass-falda-arrow">
              <line x1="0" y1="0" x2="0" y2="-28" stroke="#16a34a" strokeWidth="4" strokeLinecap="round" />
              <polygon points="0,-36 6,-26 -6,-26" fill="#16a34a" />
            </g>
          )}
          <circle r="4" fill="#0f172a" />
          {LETTERS.map(([l, a]) => {
            const r = (a * Math.PI) / 180;
            const x = 30 * Math.sin(r), y = -30 * Math.cos(r);
            return (
              <text key={l} x={x} y={y} transform={`rotate(${-rotation} ${x} ${y})`} textAnchor="middle" dominantBaseline="central"
                fontSize="13" fontWeight="800" fill={l === "N" ? "#B30000" : "#0f172a"} stroke="#fff" strokeWidth="3" paintOrder="stroke">{l}</text>
            );
          })}
        </g>
      </svg>
      {hasAz && (
        <div className="text-[11px] font-bold text-center leading-tight" style={{ color: "#166534" }} data-testid="roof-compass-falda">
          Falda: {dirName(az)} {az}°
        </div>
      )}
      {hasCoord && (
        <button type="button" onClick={copy} title="Copia coordinate" className="text-[10px] leading-tight text-center hover:underline" style={{ color: "#334155" }} data-testid="roof-compass-coords">
          {Number(lat).toFixed(6)}<br />{Number(lng).toFixed(6)}
        </button>
      )}
    </div>
  );
};
